// extracted by mini-css-extract-plugin
export default {"searchCategory":"FormCategory_searchCategory__bo1v2","form":"FormCategory_form__3Tjc7","divInput":"FormCategory_divInput__u6nr2"};